import { TEntryId, TParentState } from '../models/other'
import { ITreeStructure } from '../models/treeStructure'

import { getAllDescendantsForItem } from './getAllDescendantsForItem'

export const getTreeItemState = (
  itemId: TEntryId,
  allData: ITreeStructure[],
  selectedValues: ITreeStructure[]
): TParentState => {
  const byEntryId = (it: ITreeStructure) => it.itemId
  const item = allData.find((it) => it.itemId === itemId)
  if (!item) {
    return 'empty'
  }

  const allDescendants = getAllDescendantsForItem(item)
  const descendantsIds = allDescendants.map(byEntryId).filter((entryId) => item.itemId !== entryId)
  const idSelected = (id: TEntryId) => selectedValues.map(byEntryId).includes(id)

  const isAllDescendantsChecked = descendantsIds.every(idSelected)
  if (isAllDescendantsChecked) {
    return 'full'
  }

  const isSomeDescendantsChecked = descendantsIds.some(idSelected)
  if (isSomeDescendantsChecked) {
    return 'indeterminate'
  }

  return 'empty'
}
